import React from "react";
import { MenuItem, TextField, ListItemText } from "@material-ui/core";

const RenderPrimitiveValues = ({ item, handleChangeData, objectId }) => {
  const [key, value] = item;
  const renderBooleanSelect = (item) => {
    const [key, value] = item;

    return (
      <TextField
        name={key}
        label={key}
        value={value}
        onChange={(e) => handleChangeData(e, objectId)}
        placeholder={`type ${key} value`}
        select
        fullWidth
        margin="dense"
        style={{ width: 290 }}
        InputLabelProps={{ shrink: true }}
      >
        {[true, false].map((listItem) => (
          <MenuItem key={listItem.toString()} value={listItem}>
            <ListItemText primary={listItem.toString()} />
          </MenuItem>
        ))}
      </TextField>
    );
  };

  const renderStringInput = (item) => {
    const [key, value] = item;

    return (
      <TextField
        name={key}
        label={key}
        value={value}
        onChange={(e) => handleChangeData(e, objectId)}
        placeholder={`type ${key} value`}
        type="text"
        fullWidth
        margin="dense"
        style={{ width: 290 }}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  const renderNumberInput = (item) => {
    const [key, value] = item;

    return (
      <TextField
        name={key}
        label={key}
        value={value}
        onChange={(e) => handleChangeData(e, objectId)}
        placeholder={`type ${key} value`}
        type="number"
        fullWidth
        margin="dense"
        style={{ width: 290 }}
        InputLabelProps={{ shrink: true }}
      />
    );
  };

  return (
    <div key={key} style={{ marginTop: ".5rem" }}>
      {typeof value === "boolean" && renderBooleanSelect(item)}
      {typeof value === "number" && renderNumberInput(item)}
      {typeof value === "string" && key !== "id" && renderStringInput(item)}
    </div>
  );
};

export default RenderPrimitiveValues;
